module.exports = __webpack_public_path__ + "img/DE00718.9025dc99.png";